export const LabelModule = {
    namespaced: true,
    state: {
        loadLabelData: 1,
        LabelList: [],
        LabelFilterList: []
    }
}